import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'

import { Pagination } from '@/components/atomic/Pagination/Pagination'
import { selectPagination, selectResultsTotal } from '@/store/selectors/search'

export const SearchPagination = () => {
  const resultsTotal = useSelector(selectResultsTotal)
  const pagination = useSelector(selectPagination)
  const router = useRouter()

  const gotoPage = page => {
    const newQueryWithChangedPage = { ...router.query, page }

    router.push({
      pathname: router.pathname,
      query: newQueryWithChangedPage,
    })
  }

  if (resultsTotal > 10) {
    return (
      <div className="search-pagination">
        <Pagination
          resultTotal={resultsTotal}
          pageSize={pagination.pageSize}
          currentPage={pagination.page}
          gotoPage={gotoPage}
        />
      </div>
    )
  }

  return null
}
